// import httpClient from '../../utils/httpClient'
import auth from '../../utils/api/auth'
import user from '../../utils/api/user'

export default {
    namespaced: true,
    state: {
        accessToken: null,
        userID: null,
        devices: null,
        accessLevel: null,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Madrid'
    },
    mutations: {
        setAuth(state, payload) {
            state.accessToken = payload.accessToken
            state.userID = payload.userID
            state.devices = payload.devices
            state.accessLevel = payload.accessLevel
        },
        clearAuth(state) {
            state.accessToken = null
            state.userID = null
            state.devices = null
            state.accessLevel = null
        },
        setDevices(state, payload) {
            state.devices = payload
        }
    },
    getters: {
        getDeviceById: (state) => (id) => {
            return state.devices.find(device => device.deviceID === id)
        }

    },
    actions: {
        signup({commit}, data) {
            return auth.signup({email: data.email, password: data.password})
        },
        verifyEmailWithToken({commit}, token) {
            return auth.emailVerification({token})
        },
        resendEmailVerification({commit}, userID) {
            return auth.resendEmailVerification({userID})
        },
        recoverPassword({commit}, email) {
            return auth.recover({email})
        },
        resetPassword({commit}, data) {
            return user.resetPassword(data.token, data.userID, { password: data.password})
        },
        login({commit}, data) {
            return new Promise((resolve, reject) => {
                auth.login({type: 'userCredentials', email: data.email, password: data.password})
                .then((result) => {
                    if(result) {
                        commit('setAuth', result)
                        resolve(result)
                    }
                    reject(false)
                })
                .catch((err) => {
                    reject(err)
                })
            })
            
        },
        logout({commit}) {
            commit('clearAuth')
            return true
        },
        refreshToken({commit, state}) {
            return new Promise((resolve, reject) => {
                auth.login({type: 'token', token: state.accessToken})
                .then((result) => {
                    if(result) {
                        commit('setAuth', result)
                        resolve(result)
                    }
                    reject(false)
                })
                .catch((err) => {
                    reject(err)
                })
            })
        },
        setDevices({commit}, data) {
            commit('setDevices', data.devices)
            return true
        }

    }
}